import { render, staticRenderFns } from "./DecisionCard.vue?vue&type=template&id=0c970dac&scoped=true&"
import script from "./DecisionCard.vue?vue&type=script&lang=ts&"
export * from "./DecisionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c970dac",
  null
  
)

export default component.exports